import {combineReducers} from 'redux';
import * as ActionTypes from '../constants/ActionTypes';

// Import the actions types constant we defined in our actions
import search from './search';
import searchnotissue from './searchnotissue';
import loading from './loading';
import booking from './booking';
import msg from './msg';
import alertMsg from './alertMsg';
import roster from './roster';

const initialState = {
	profileInfo: null,
	unreadMsg: [],
	currencyList: null,
	bkgPickCompanyArr: null,
	defaultPickCompany: null,
};

const ConvertPickCompanyToArr = (bkgPickCompanyStr) => {
	var bkgPickCompanyArr = null;
	if (bkgPickCompanyStr) {
		var bkgPickCompanyObj = JSON.parse(bkgPickCompanyStr)
		bkgPickCompanyArr = []
		for (var key in bkgPickCompanyObj) {
			if (bkgPickCompanyObj.hasOwnProperty(key)) {
				bkgPickCompanyArr.push({
					value: bkgPickCompanyObj[key],
					label: key
				});
			}
		}
	}
	return bkgPickCompanyArr;
}

const GetDefaultPickCompany = (bkgPickCompanyArr, typecode) => {
	var defaultPickCompany = null;
	for (var i = 0; i < bkgPickCompanyArr?.length; i++) {
		if (bkgPickCompanyArr[i].value === typecode) {
			defaultPickCompany = bkgPickCompanyArr[i].value;
			break;
		}
	}
	if(defaultPickCompany === null && bkgPickCompanyArr?.length > 0) {
		defaultPickCompany = bkgPickCompanyArr[0].value;
	}
	return defaultPickCompany;
}


const general = (state = initialState, action) => {
	switch (action.type) {
	case ActionTypes.GET_PROFILE_SUCCESS:
		var bkgPickCompanyStr = action.payload?.accessControl?.HFS_BKG_PICK_COMPANY;
		var bkgPickCompanyArr = ConvertPickCompanyToArr(bkgPickCompanyStr);
		var defaultPickCompany = GetDefaultPickCompany(bkgPickCompanyArr, action.payload?.typeCode);
		return Object.assign({}, state, {
			profileInfo: action.payload,
			bkgPickCompanyArr: bkgPickCompanyArr,
			defaultPickCompany: defaultPickCompany
		});
	case ActionTypes.GET_UNREAD_MSG_SUCCESS:
		return Object.assign({}, state, {
			unreadMsg: action.payload
		});
	case ActionTypes.GET_CURRENCY_LIST_SUCCESS:
		return Object.assign({}, state, {
			currencyList: action.payload
		});
	default:
		return state;
	}
};

// Combine all the reducers
const rootReducer = combineReducers({
  general,
  loading,
	search,
	searchnotissue,
	booking,
	msg,
	alertMsg,
	roster,
})

export default rootReducer;
